import { render } from "./Index.vue?vue&type=template&id=54c7fb9b&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=54c7fb9b&lang=less&scoped=true"

import exportComponent from "E:\\qq\\前端(1)\\前端\\后台vue\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c7fb9b"]])

export default __exports__